import { DateTime } from 'luxon';

export const utc = (epoch?: string | number) =>
  epoch ? DateTime.fromSeconds(parseInt(epoch, 10), { zone: 'utc' }) : DateTime.utc();

export const at = (dateTime?: DateTime) => (dateTime instanceof DateTime ? dateTime : utc());

export const epoch = (dateTime?: DateTime) => at(dateTime).toSeconds();

export const tz = (dateTime?: DateTime, timeZone?: string) =>
  at(dateTime).setZone(timeZone || 'utc');

export const format = (
  dateTime?: DateTime,
  dateTimeFormat?: string,
  locale?: string,
  localeFormat?: any
) =>
  /* TODO Hardcoded formatting until calls are fixed in ST */
  dateTimeFormat
    ? at(dateTime).toFormat('dd/MM/yyyy')
    : at(dateTime).toLocaleString(localeFormat || DateTime.DATETIME_SHORT, {
        locale: locale || 'en-AU'
      });
/* TODO Hardcoded formatting until calls are fixed in ST */

export const formatDate = (dateTime?: DateTime, locale?: string, preset?: any) =>
  format(dateTime, null, locale, preset || DateTime.DATE_SHORT);

export const formatDateTime = (dateTime?: DateTime, locale?: string, preset?: any) =>
  format(dateTime, null, locale, preset || DateTime.DATETIME_SHORT);

export const formatTime = (dateTime?: DateTime, locale?: string, preset?: any) =>
  format(dateTime, null, locale, preset || DateTime.TIME_SIMPLE);

export const formatEpochAsDate = (
  timeStamp?: number,
  timeZone?: string,
  locale?: string,
  preset?: any
) => (timeStamp ? formatDate(tz(utc(timeStamp), timeZone), locale, preset) : '');

export const formatEpochAsDateTime = (
  timeStamp?: number,
  timeZone?: string,
  locale?: string,
  preset?: any
) => (timeStamp ? formatDateTime(tz(utc(timeStamp), timeZone), locale, preset) : '');

export const formatEpochAsTime = (
  timeStamp?: number,
  timeZone?: string,
  locale?: string,
  preset?: any
) => (timeStamp ? formatTime(tz(utc(timeStamp), timeZone), locale, preset) : '');

export const future = (dateTime?: DateTime, timeUnit?: string, timeDuration?: number) =>
  at(dateTime).plus({ [timeUnit]: timeDuration });

export const past = (dateTime?: DateTime, timeUnit?: string, timeDuration?: number) =>
  at(dateTime).minus({ [timeUnit]: timeDuration });

export default {
  at,
  epoch,
  format,
  formatDate,
  formatDateTime,
  formatEpochAsDate,
  formatEpochAsDateTime,
  formatEpochAsTime,
  formatTime,
  future,
  past,
  tz,
  utc
};
